import Reveal from "@/components/Reveal";
import { Crosshair, TechLabel } from "@/components/Bits";
import KineticLines from "@/components/KineticLines";

export default function SectionHead({ index, eyebrow, title, sub, className = "" }) {
  return (
    <div className={`relative border-b border-white/10 pb-10 md:pb-14 ${className}`}>
      <Crosshair className="-left-1 -top-1 text-lg" />
      <Reveal>
        <TechLabel className="text-molten">
          {index ? `${index} / ` : ""}
          {eyebrow}
        </TechLabel>
      </Reveal>
      <KineticLines
        as="h2"
        lines={[title]}
        className="mt-5 font-display text-4xl font-semibold uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
        lineClassName="lg:whitespace-pre-line"
        delay={0.05}
      />
      {sub && (
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-fog md:text-lg">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
